// Homepage promise sections (snippets/home-promises.liquid): reveal items and draw icon strokes once
// in view ("is-in"), and keep the small icon loops running only while the section is on screen
// ("is-live") so off-screen sections cost nothing. Without IntersectionObserver or with reduced
// motion, everything simply shows.
// The strip under the hero is also a looping carousel ([data-hp-carousel]): it advances one promise
// every few seconds while on screen, pauses while the shopper touches, hovers or focuses it, and jumps
// back silently once it reaches the aria-hidden copy so the loop never visibly rewinds.
(() => {
  const sections = document.querySelectorAll('[data-promise]');
  if (!sections.length) return;
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  if ('IntersectionObserver' in window && !reduceMotion) {
    document.documentElement.classList.add('hp-anim');
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) entry.target.classList.add('is-in');
        entry.target.classList.toggle('is-live', entry.isIntersecting);
      }
    }, { threshold: 0.2 });
    sections.forEach((section) => observer.observe(section));
  }

  const DELAY = 3200;
  const RESUME = 4000;

  document.querySelectorAll('[data-hp-carousel]').forEach((track) => {
    const count = Number(track.dataset.count) || 0;
    const items = track.children;
    if (!count || items.length <= count) return;
    const section = track.closest('[data-promise]');
    let paused = false;
    let resumeTimer = 0;
    let visible = !('IntersectionObserver' in window);

    const step = () => items[1].offsetLeft - items[0].offsetLeft;
    const loopWidth = () => items[count].offsetLeft - items[0].offsetLeft;

    // Keep the scroll position inside the first set so there is always a copy ahead.
    const wrap = () => {
      const width = loopWidth();
      if (width > 0 && track.scrollLeft >= width - 2) track.scrollTo({ left: track.scrollLeft - width, behavior: 'instant' });
    };

    const advance = () => {
      if (paused || !visible || document.hidden || reduceMotion) return;
      wrap();
      track.scrollTo({ left: track.scrollLeft + step(), behavior: 'smooth' });
    };

    const pause = () => {
      paused = true;
      clearTimeout(resumeTimer);
    };
    const resumeSoon = () => {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => { paused = false; }, RESUME);
    };

    track.addEventListener('pointerenter', pause);
    track.addEventListener('pointerdown', pause);
    track.addEventListener('focusin', pause);
    track.addEventListener('pointerleave', resumeSoon);
    track.addEventListener('pointerup', resumeSoon);
    track.addEventListener('focusout', resumeSoon);
    track.addEventListener('touchend', resumeSoon, { passive: true });
    if ('onscrollend' in window) track.addEventListener('scrollend', wrap);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        visible = entries[entries.length - 1].isIntersecting;
      }, { threshold: 0.5 }).observe(section || track);
    }

    setInterval(advance, DELAY);
  });
})();
